<div *ngIf="!miniSideBar" class="company-logo" fxLayoutAlign="center center">
    <img *ngIf="mobileQuery.matches" [src]="logo" alt="logo" style="width: 176px;">
    <mat-icon class="close-menu" (click)="closeMenu()" *ngIf="!mobileQuery.matches">close</mat-icon>
</div>

<div *ngIf="miniSideBar" class="company-logo" fxLayoutAlign="center center">
    <img class="company-logo-icon" [src]="icon" alt="logo">
</div>
<!-- <div fxLayoutAlign="center center">
    <button (click)="switchLanguage('pt-BR')"
            class="language-button"
            [ngClass]="{'language-button-selected': currentLanguage === 'pt-BR'}">
      <div class="faIcon">
        <img src="../../../../assets/images/flags/BR.svg"
             alt="Português"
             [ngStyle]="{'width.px': miniSideBar ? 15 : null}">
      </div>
    </button>
  
    <button (click)="switchLanguage('en')"
            class="language-button"
            [ngClass]="{'language-button-selected': currentLanguage === 'en'}">
      <div class="faIcon">
        <img src="../../../../assets/images/flags/US.svg"
             alt="English"
             [ngStyle]="{'width.px': miniSideBar ? 15 : null}">
      </div>
    </button>
</div> -->

<mat-nav-list appMenu>
    <mat-list-item appMenuLink *ngFor="let menuitem of menu" routerLinkActive="selected"
        [ngClass]="setSelectedSubmenu(formatRouterLink(menuitem.module, menuitem.state, ''))" group="{{menuitem.state}}"
        (click)="scrollToTop()">

        <a appMenuToggle [routerLink]="[menuitem.module, menuitem.state]"
            *ngIf="(menuitem.type === 'link') && validateItemMenu(menuitem.state)"
            [style.justify-content]="miniSideBar ? 'start' : 'unset'">
            <div class="faIcon">
                <fa-icon *ngIf="!menuitem.useAssets" [icon]="menuitem.icon" size="lg"></fa-icon>
                <img *ngIf="menuitem.useAssets && menuitem.assetPath !== 'assets/icons/icon-pix-outline.svg'" [src]="menuitem.assetPath">
                <svg *ngIf="menuitem.useAssets && menuitem.assetPath === 'assets/icons/icon-pix-outline.svg'" 
                     width="20" 
                     height="20" 
                     viewBox="0 0 512 512" 
                     xmlns="http://www.w3.org/2000/svg"
                     [ngStyle]="{'color': sideMenuTextColor}">
                  <g fill="currentColor" fill-rule="evenodd">
                    <path d="M393.072 391.897c-20.082 0-38.969-7.81-53.176-22.02l-77.069-77.067c-5.375-5.375-14.773-5.395-20.17 0l-76.784 76.786c-14.209 14.207-33.095 22.019-53.179 22.019h-9.247l97.521 97.52c30.375 30.375 79.614 30.375 109.988 0l97.239-97.238h-15.123zm-105.049 74.327c-8.55 8.53-19.93 13.25-32.05 13.25h-.02c-12.12 0-23.522-4.721-32.05-13.25l-56.855-56.855c7.875-4.613 15.165-10.248 21.758-16.84l63.948-63.948 64.23 64.23c7.637 7.66 16.188 14.013 25.478 18.952l-54.439 54.46zM310.958 22.78c-30.374-30.374-79.613-30.374-109.988 0l-97.52 97.52h9.247c20.082 0 38.97 7.834 53.178 22.02l76.784 76.785c5.57 5.592 14.622 5.57 20.17 0l77.069-77.068c14.207-14.187 33.094-22.02 53.176-22.02h15.123l-97.239-97.237zm6.028 96.346l-64.23 64.23-63.97-63.97c-6.593-6.592-13.86-12.206-21.736-16.818l56.853-56.877c17.69-17.645 46.476-17.668 64.121 0l54.44 54.461c-9.292 4.961-17.842 11.315-25.479 18.974h.001z"/>
                    <path d="M489.149 200.97l-58.379-58.377h-37.706c-13.838 0-27.394 5.635-37.185 15.426l-77.068 77.069c-7.202 7.18-16.623 10.77-26.067 10.77-9.443 0-18.885-3.59-26.066-10.77l-76.785-76.785c-9.792-9.814-23.346-15.427-37.207-15.427h-31.81L22.78 200.97c-30.374 30.375-30.374 79.614 0 109.988l58.095 58.074 31.81.021c13.86 0 27.416-5.635 37.208-15.426l76.784-76.764c13.925-13.947 38.208-13.924 52.133-.02l77.068 77.066c9.791 9.792 23.346 15.405 37.185 15.405h37.706l58.379-58.356c30.374-30.374 30.374-79.613 0-109.988zm-362.19 129.724c-3.763 3.786-8.942 5.917-14.273 5.917H94.302l-48.59-48.564c-17.689-17.69-17.689-46.476 0-64.143L94.3 175.296h18.385c5.331 0 10.51 2.154 14.295 5.918l74.74 74.74-74.761 74.74zm339.257-42.647l-48.848 48.87h-24.305c-5.309 0-10.508-2.155-14.251-5.92l-75.023-75.043 75.023-75.023c3.743-3.764 8.942-5.918 14.252-5.918h24.304l48.847 48.891c8.573 8.551 13.273 19.93 13.273 32.05 0 12.141-4.7 23.52-13.273 32.093z"/>
                  </g>
                </svg>
            </div>
            <span>{{ translateValue(menuitem.name) }}</span>
            <span fxFlex></span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value}}</span>
        </a>


        <a appMenuToggle href="javascript:;" *ngIf="menuitem.type === 'sub' && validateItemMenu(menuitem.state)"
            class="app-menu-toggle" [style.justify-content]="miniSideBar ? 'start' : 'unset'"
            (click)="menuTrigger.toggleMenu()" [ngClass]="{'escrow' : menuitem.state == 'conta-escrow'}">
            <div class="faIcon">
                <fa-icon *ngIf="!menuitem.useAssets" [icon]="menuitem.icon" size="lg"></fa-icon>
                <img *ngIf="menuitem.useAssets && menuitem.assetPath !== 'assets/icons/icon-pix-outline.svg'" [src]="menuitem.assetPath">
                <svg *ngIf="menuitem.useAssets && menuitem.assetPath === 'assets/icons/icon-pix-outline.svg'" 
                     width="20" 
                     height="20" 
                     viewBox="0 0 512 512" 
                     xmlns="http://www.w3.org/2000/svg"
                     [ngStyle]="{'color': sideMenuTextColor}">
                  <g fill="currentColor" fill-rule="evenodd">
                    <path d="M393.072 391.897c-20.082 0-38.969-7.81-53.176-22.02l-77.069-77.067c-5.375-5.375-14.773-5.395-20.17 0l-76.784 76.786c-14.209 14.207-33.095 22.019-53.179 22.019h-9.247l97.521 97.52c30.375 30.375 79.614 30.375 109.988 0l97.239-97.238h-15.123zm-105.049 74.327c-8.55 8.53-19.93 13.25-32.05 13.25h-.02c-12.12 0-23.522-4.721-32.05-13.25l-56.855-56.855c7.875-4.613 15.165-10.248 21.758-16.84l63.948-63.948 64.23 64.23c7.637 7.66 16.188 14.013 25.478 18.952l-54.439 54.46zM310.958 22.78c-30.374-30.374-79.613-30.374-109.988 0l-97.52 97.52h9.247c20.082 0 38.97 7.834 53.178 22.02l76.784 76.785c5.57 5.592 14.622 5.57 20.17 0l77.069-77.068c14.207-14.187 33.094-22.02 53.176-22.02h15.123l-97.239-97.237zm6.028 96.346l-64.23 64.23-63.97-63.97c-6.593-6.592-13.86-12.206-21.736-16.818l56.853-56.877c17.69-17.645 46.476-17.668 64.121 0l54.44 54.461c-9.292 4.961-17.842 11.315-25.479 18.974h.001z"/>
                    <path d="M489.149 200.97l-58.379-58.377h-37.706c-13.838 0-27.394 5.635-37.185 15.426l-77.068 77.069c-7.202 7.18-16.623 10.77-26.067 10.77-9.443 0-18.885-3.59-26.066-10.77l-76.785-76.785c-9.792-9.814-23.346-15.427-37.207-15.427h-31.81L22.78 200.97c-30.374 30.375-30.374 79.614 0 109.988l58.095 58.074 31.81.021c13.86 0 27.416-5.635 37.208-15.426l76.784-76.764c13.925-13.947 38.208-13.924 52.133-.02l77.068 77.066c9.791 9.792 23.346 15.405 37.185 15.405h37.706l58.379-58.356c30.374-30.374 30.374-79.613 0-109.988zm-362.19 129.724c-3.763 3.786-8.942 5.917-14.273 5.917H94.302l-48.59-48.564c-17.689-17.69-17.689-46.476 0-64.143L94.3 175.296h18.385c5.331 0 10.51 2.154 14.295 5.918l74.74 74.74-74.761 74.74zm339.257-42.647l-48.848 48.87h-24.305c-5.309 0-10.508-2.155-14.251-5.92l-75.023-75.043 75.023-75.023c3.743-3.764 8.942-5.918 14.252-5.918h24.304l48.847 48.891c8.573 8.551 13.273 19.93 13.273 32.05 0 12.141-4.7 23.52-13.273 32.093z"/>
                  </g>
                </svg>
            </div>
            <span>{{ translateValue(menuitem.name) }}</span>
            <span fxFlex></span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
            <mat-icon class="dd-icon">keyboard_arrow_right</mat-icon>
            <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="submenu" (menuOpened)="onOpenedSubmenu()"
                (menuClosed)="onClosedSubmenu()"></div>
        </a>

        <mat-menu appSubmenu #submenu="matMenu" class="mat-sub-menu" panelClass="mat-sub-menu-panel">

            <h3 class="title">{{ translateValue(menuitem.name) }}</h3>
            <div *ngIf="!menuitem.subtype">
                <content *ngFor="let childitem of menuitem.children; let j = index;">
                    <a mat-menu-item appSubmenuLink
                        [routerLink]="['/', menuitem.module, menuitem.state, childitem.state]" class="sub-item"
                        *ngIf="validateSubItemMenu(childitem.state)"
                        [ngClass]="setSelectedSubmenu(formatRouterLink(menuitem.module, menuitem.state, childitem.state))"
                        [partialPath]="formatRouterLink(menuitem.module, menuitem.state, childitem.state)">
                        <div appSubmenuToggle>
                            {{ translateValue(childitem.name) }}
                        </div>
                    </a>
                </content>
            </div>
            <div *ngIf="menuitem.subtype === 'subtitle'">
                <content *ngFor="let childitem of menuitem.children; let j = index;">

                    <div class="subnav" class="mat-elevation-z0" *ngIf="validateSubItemMenu(childitem.state)">
                        <div class="subnav-header" (click)="closeHeaderSubnav($event, childitem)">
                            <div fxLayout="row" fxLayoutAlign="start center">

                                <span>{{ translateValue(childitem.name) }}</span>
                            </div>
                            <i *ngIf="childitem.active" class="fas fa-chevron-up subnav-icon"></i>
                            <i *ngIf="!childitem.active" class="fas fa-chevron-down subnav-icon"></i>
                        </div>
                        <div class="subnav-body" *ngIf="childitem.active">
                            <content *ngFor="let subchildrenItem of childitem.subchildren; let j = index;">
                                <a mat-menu-item appSubmenuLink
                                    [routerLink]="['/', menuitem.module, menuitem.state, subchildrenItem.state]"
                                    class="sub-item"
                                    [ngClass]="setSelectedSubmenu(formatRouterLink(menuitem.module, menuitem.state, subchildrenItem.state))"
                                    [partialPath]="formatRouterLink(menuitem.module, menuitem.state, subchildrenItem.state)"
                                    (click)="track(subchildrenItem.name)">
                                    <div appSubmenuToggle>
                                        {{ translateValue(subchildrenItem.name) }}
                                    </div>
                                </a>
                            </content>
                        </div>
                    </div>
                </content>
            </div>

        </mat-menu>

    </mat-list-item>

    <div [ngClass]="{'close-expand' : !miniSideBar, 'close-expand-mini' : miniSideBar}" (click)="menuAction()">
        <mat-icon>{{ this.miniSideBar == false ? 'keyboard_arrow_left' : 'keyboard_arrow_right' }}</mat-icon>
    </div>
</mat-nav-list>

<div style="align-self:flex-end" [ngClass]="{'user-profile2' : !miniSideBar, 'user-profile2-mini' : miniSideBar}"
    *ngIf="mobileQuery.matches">
    <div #accountsContainer class="accounts" fxLayout="row wrap" fxLayoutAlign="center center">

        <div fxFlex="100" fxLayout="row">

            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center">
                <div fxFlex="18" class="m-r-10" (click)="openPopUp()">
                    <img *ngIf="image" [src]="image" style="border-radius: 50%;">
                    <div *ngIf="!image" class="user-profile-menu-no-photo">
                        <span> {{getInitialFromName()}}</span>
                    </div>
                </div>

                <div fxFlex="72" (click)="openPopUp()">
                    <span class="user-name">{{getTypeAndNameAccount(selectedAccount?.holderTaxId,
                        selectedAccount?.holderName)}}</span>
                    <div class="user-account">
                        <span>{{"Account" | translate}}: {{selectedAccount?.account ? selectedAccount?.account : "MASTER"}}</span>
                    </div>
    
                </div>

                <div fxFlex="10" (click)="menuUserTrigger.openMenu()" fxLayout="column" fxLayoutAlign="center center" class="account-icon-right">
                    <mat-icon style="padding-left: 8px !important;">arrow_right</mat-icon>
                </div>
            </div>

        </div>

        <div #menuUserTrigger="matMenuTrigger" [matMenuTriggerFor]="submenuUser" (menuOpened)="onOpenedSubmenu()"
            (menuClosed)="onClosedSubmenu()"></div>
    </div>
    <div #accountsPop *ngIf="accounts.length > 1 && open" class="accounts-pop">
        <div (click)="chosenAccount(i)" *ngFor="let account of accounts; let i = index"
            [class.account-select]="selectedAccount?.accountIndex !== account.accountIndex"
            [class.account-selected]="selectedAccount?.accountIndex === account.accountIndex">
            <div>
                <div>
                    <span>{{getTypeAndNameAccount(account?.operatorConfigProfile?.userHolderTaxId,
                        (account?.alias ||
                        account?.holderName))}}</span>
                </div>
                <div>
                    {{account.accountIndex.replace("_", " ")}}
                </div>
            </div>
        </div>
    </div>
</div>

<mat-menu #submenuUser="matMenu" class="mat-sub-menu mat-sub-menu-profile" panelClass="mat-sub-menu-panel">

    <h3 class="title">
        {{ name }}
    </h3>

    <div class="perfil" (click)="showPerfil()">
        {{"My-profile" | translate}}
    </div>

    <div class="perfil" (click)="showAbout()">
        {{"About" | translate}}
    </div>

    <div class="perfil" (click)="logout()">
        {{"Exit" | translate}}
    </div>

</mat-menu>